import loadable from "@loadable/component";
import CreateIcon from "../../Icons/Create";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";

const EditWarehouseComponent = loadable(
  () => import("../../components/Warehouse/EditWarehouse")
);
const EditWarehouse = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`warehouse-${id}`],
    url: `${APIS.WAREHOUSE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`warehouse-${id}`],
    navigateURL: "/warehouse",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.WAREHOUSE}${id}/`;
    let formData = {
      ...values,
      "primary_contact": `+977${values?.primary_contact}`,
      "secondary_contact":values?.secondary_contact? `+977${values?.secondary_contact}`: `+977${values?.mobile_number}`
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Warehouse</span>
      </div>
      <EditWarehouseComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
      />
    </>
  );
};
export default EditWarehouse;
